import { Form, FormInstance } from 'antd';
import Empty from 'components/Empty';
import React, { forwardRef, useImperativeHandle, useMemo } from 'react';
import styled from 'styled-components';
import { getTimeSections } from './helpers';
import useQueryAvailableTimeSlotStaff from './useQueryAvailableTimeSlotStaff';
type TimeSlotStepRef = {
  fetch: (date: string, staffId?: string, duration?: number) => void;
};
export const timeSlotStepRef = React.createRef<TimeSlotStepRef>();
type TimeSlotStepProps = {
  v3?: boolean;
};
const TimeSlotStep = forwardRef<TimeSlotStepRef, TimeSlotStepProps>(({ v3 = false }, ref) => {
  const form = Form.useFormInstance();
  const [, fetch] = useQueryAvailableTimeSlotStaff({
    onStart() {
      if (v3) {
        form.resetFields(['startTime', 'TIME_SLOT_VALID']);
      } else {
        form.resetFields(['startTime', 'SERVICE_VALID']);
      }
    },
    onDone(data) {
      form.setFieldValue('timeslots', data);
    },
  });

  const handleFetch = (date: string, staffId?: string, duration?: number) => {
    fetch(date, staffId || '', duration || undefined);
  };

  useImperativeHandle(ref, () => ({
    fetch: handleFetch,
  }));

  return (
    <>
      <Container>
        <Form.Item noStyle name={'startTime'} rules={[{ required: true, message: 'please choose start time' }]}>
          <Timeslots />
        </Form.Item>
      </Container>
    </>
  );
});
TimeSlotStep.displayName = 'TimeSlotStep';
export default TimeSlotStep;

const Container = styled.div`
.CalendarAntUI {
  margin: 0 -8px;
  .ant-picker-cell .box {
    color: #1D2129;
    height: 30px;
    width: 30px;
    text-align: center;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .ant-picker-cell.ant-picker-cell-selected .box{
    color: #fff;
    background: #2463EB;
    
  }
  .ant-picker-content tbody td {
    height: 20px;
    padding: 0;
  }

  .ant-picker-content thead th {
    color: #505050;
    text-align: center;
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px; /* 214.286% */
    text-transform: capitalize;
  }
}
`;

type TimeslotsProps = {
  value?: string;
  onChange?: (value: string) => void;
  form?: FormInstance<any>;
};
const Timeslots = ({ form, value: dateValue = '', onChange = () => undefined }: TimeslotsProps) => {
  const timeslots: string[] = Form.useWatch('timeslots', form);
  const sections = useMemo(() => getTimeSections(timeslots), [timeslots]);
  const handleChangeStartTime = (o: string) => {
    form?.resetFields(['SERVICE_VALID']);
    onChange?.(o);
  };

  if (!timeslots?.length) return (
    <Empty description='No available' />
  );

  return (
    <ContainerBox>
      {sections.morning.length > 0 && <div className='time-slot-section'>
        <div className="section-sublabel">Morning</div>
        <StartTimeChange value={dateValue} timeslots={sections.morning} onChange={handleChangeStartTime} />
      </div>}
      {sections.afternoon.length > 0 && <div className='time-slot-section'>
        <div className="section-sublabel">Afternoon</div>
        <StartTimeChange value={dateValue} timeslots={sections.afternoon} onChange={handleChangeStartTime} />
      </div>}
      {sections.evening.length > 0 && <div className='time-slot-section'>
        <div className="section-sublabel">Evening</div>
        <StartTimeChange value={dateValue} timeslots={sections.evening} onChange={handleChangeStartTime} />
      </div>}
    </ContainerBox>
  );
};

const StartTimeChange = ({ value, onChange, timeslots = [] }: { value?: string, onChange?: (value: string) => void; timeslots?: string[] }) => {
  return (
    <TimeslotsContainer>
      {timeslots.map((o: string) => (
        <button type='button' onClick={() => onChange?.(o)} key={o} className={`start-time-item ${value === o ? 'active' : ''}`}>
          <span>{o}</span>
        </button>
      ))}
    </TimeslotsContainer>
  );
};

const ContainerBox = styled.div`

.time-slot-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  margin-bottom: 8px;
}

.section-sublabel {
  color: #505050;
  text-align: left;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 4px;
}
`;

const TimeslotsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  align-self: stretch;
  gap: 8px;
  .start-time-item {
    display: flex;
    height: 40px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border: 1px solid #CCD4DC;
    background: #FFF;
    span {
      color: #1D2129;
      text-align: center;
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    &.active {
      border: 1px solid #2463EB;
      background: #2463EB;
      span {
        color: #FFF;
      }
    }
  }
`;